import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import { baseMediaUrls } from '../../utils/constants';
import { getDarkerThemeColor, getLighterThemeColor } from "../theme/colors";
import VideoPlayer from './VideoPlayer';
import AudioPlayer from './AudioPlayer';
import theme from '../theme';


const ErrorMessage = styled.div`
  width: 100%;
  padding: 2rem;
  background-color: ${(props) => getLighterThemeColor(props.theme.colors.ACTION, 0.8)};
  color: ${(props) => getDarkerThemeColor(props.theme.colors.ACTION)};
  border: 1px solid ${(props) => props.theme.colors.ERROR_RED};
  border-radius: 8px;
  text-align: center;
`;

const MediaPlayer = ({ previewContent, posterImage, isAudio = false, themeColor, maxHeight, downloadFile }) => {

  // const url= "//coursio.s3-eu-west-1.amazonaws.com/8320075e77fede6a6422f89d1945a48e/b413763961f605bfa05c5d4a12c1237a/7c0db16b3a62e9b754ae6cb4aacf91e53dd3c7ef70b76ee788f439b2fa1c0157.jpg"
  // const vimeoCoursioUrl = `https://vimeo.com/375688422`//`https://vimeo.com/565617079`
  // const vimeoPublicUrl = `https://player.vimeo.com/video/591721025`
  // const wrongVideoUrl = `//coursio.s3-eu-west-1.amazonaws.com/b1be259d8e3577c0d3d06f2379c6dd9c/6eaced2908a59a5e1e9a56345efb5456/76178e82af91ffe607a3231ad22a47e9ee5bd72d6bb2c0117f971f96af24f7d1`
  // const youtubeVideourl = 'https://youtu.be/xFEAOzWLx8Y'

  // previewContent = youtubeVideourl
  const { t } = useTranslation();
  const [canPlayMedia, setCanPlayMedia] = useState(true);
  const [isOldStructure, setIsOldStructure] = useState(false);
  const [embedUrl, setEmbedUrl] = useState();

  useEffect(() => {
    try {
      if (typeof JSON.parse(previewContent) === 'object' && previewContent !== null) {
        setIsOldStructure(true);
      }
    } catch (error) {}

    if (isOldStructure) {
      const embedData = JSON.parse(previewContent);

      setEmbedUrl(`${baseMediaUrls[embedData.provider]}${embedData.src}`);
    }
  }, [previewContent, isOldStructure])

  const handleError = useCallback(err => {
    console.log('Media ERROR', err)
    setCanPlayMedia(false)
  }, [setCanPlayMedia])

  return (
    <>
      {isAudio ? <>
        <AudioPlayer url={isOldStructure ? embedUrl : previewContent} miniAudio={true} themeColor={themeColor || theme.colors.PRIMARY} downloadFile={downloadFile} />
        </>
        : canPlayMedia ? 
          <VideoPlayer 
            url={isOldStructure ? embedUrl : previewContent}
            handleError={handleError}
            posterImage={posterImage}
            themeColor={themeColor}
            downloadFile={downloadFile}
          />
          : <ErrorMessage>
              {t('media.fileContactSupport')}
            </ErrorMessage>
      }
    </>
  );
};

export default MediaPlayer;
